<template>
  <div class="default-modal">
    <el-dialog
      :model-value="showRejectTestPopup"
      width="50%"
      top="2%"
      @close="onClose"
    >
      <!-- Header -->
      <div class="dialog-header">
        <span class="header-part">Select Tests to Reject</span>
        <el-button
          size="medium"
          class="el-white"
          type="button"
          plain
          @click="onClose"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
        </el-button>
      </div>

      <!-- Panels -->
      <div class="popup-date pb-3">
        <div class="rejectedCases">
          <div v-if="groupedTests && Object.keys(groupedTests).length">
            <!-- First: ALL_TESTS and SEND_OUTS -->
            <template
              v-for="panelCode in ['ALL_TESTS', 'SEND_OUTS']"
              :key="panelCode"
            >
              <div v-if="groupedTests[panelCode]" class="panelBlock">
                <div class="categoryOnlyHeader">
                  <span class="panel-name">{{
                    groupedTests[panelCode].title
                  }}</span>
                </div>
                <div class="testNamesGridBlock">
                 <div
                    v-for="test in groupedTests[panelCode].tests"
                    :key="test._id"
                    class="testNames"
                  >
                  <el-checkbox-group :model-value="selectedTestIds">
                    <el-checkbox
                      :label="test._id"
                      @change="
                        emitUpdateIndividualTest(
                          test._id,
                          $event,
                          groupedTests[panelCode].panel_id,
                          groupedTests[panelCode].case_type_code,
                          test.test_name,
                          test.test_code,
                          test.lab_order_code,
                          test.testgo_order_code,
                          panelCode
                        )
                      "
                    >
                      <span class="test-name">{{ test.test_name }}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
              </div>
            </template>

            <!-- Then: Remaining Panels -->
            <div class="panelsGridWrapper">
              <template
                v-for="(panelData, panelCode) in groupedTests"
                :key="panelCode"
              >
                <div
                  v-if="panelCode !== 'ALL_TESTS' && panelCode !== 'SEND_OUTS'"
                  class="panelGridItem"
                >
                  <el-checkbox
                    :model-value="!!selectedPanels[panelCode]"
                    @change="emitSelectPanelTests(panelCode, $event)"
                  >
                    <span class="panel-name">{{
                      panelData.title
                    }}</span></el-checkbox
                  >
                </div>
              </template>
            </div>
          </div>
          <div v-else class="no-data-message">
            No tests available to reject.
          </div>
        </div>

        <!-- Rejection Reason Form -->
        <el-form ref="ruleForm" :model="formData">
          <el-form-item prop="selectedReasons">
            <label>Reasons for Rejection</label>
            <span class="star">*</span>
            <el-select
              :model-value="formData.selectedReasons"
              placeholder="Choose reasons"
              multiple
              filterable
              allow-create
              collapse-tags
              default-first-option
              style="width: 100%"
              @change="emitUpdateReasons"
            >
              <el-option
                v-for="reason in predefinedReasons"
                :key="reason.value"
                :label="reason.label"
                :value="reason.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item prop="notes">
            <label>Additional Notes</label>
            <span class="star">*</span>
            <el-input
              type="textarea"
              rows="2"
              placeholder="Enter notes"
              :model-value="formData.notes"
              @update:model-value="emitUpdateNotes"
            />
            <p class="note-hint">
              <b>Note:</b> Minimum 3 characters are required
            </p>
          </el-form-item>

          <el-form-item prop="image" label="Attach Image (Required)">
            <el-upload
              class="upload-demo"
              :auto-upload="false"
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              :file-list="fileList"
              :limit="1"
              accept="image/*"
              :show-file-list="true"
            >
              <el-button type="primary" v-if="!formData.image">Select Image</el-button>
              <template #tip>
                <div class="el-upload__tip" v-if="!formData.image">Image file is required</div>
              </template>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="rejectCaseError" class="error-message">
        {{ rejectCaseError }}
      </div>

      <div class="testRejectedFooter">
        <el-button
          class="testRejectedBtn"
          type="danger"
          :disabled="isRejectButtonDisabled"
          v-loading="loading"
          @click="validateAndEmit"
        >
          Reject Selected Tests
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reasonToActionMap } from "@/config/constants/rejectionReasons";

export default {
  name: "TestsRejectPopup",
  props: {
    showRejectTestPopup: Boolean,
    groupedTests: Object,
    selectedTests: Object,
    selectedPanels: Object,
    formData: Object,
    loading: Boolean,
    rejectCaseError: String,
    isRejectButtonDisabled: Boolean,
    predefinedReasons: Array,
  },
  data() {
    return {
      fileList: [],
      reasonToActionMap,
    };
  },
  computed: {
    selectedTestIds() {
      const selected = this.selectedTests || {};
      return Object.keys(selected).filter((id) => !!selected[id]);
    },
  },
 
  methods: {
    onClose() {
      this.fileList = [];
      this.$emit("update-image", null);
      this.$emit("close-popup");
    },
    handleImageChange(file) {
      this.fileList = [file];
      this.$emit("update-image", file.raw);
    },
    handleImageRemove() {
      this.fileList = [];
      this.$emit("update-image", null);
    },
    emitUpdateIndividualTest(
      testId,
      isChecked,
      panelId,
      caseTypeCode,
      testName,
      testCode,
      labOrderCode,
      testgoOrderCode,
      panelCode
    ) {
      this.$emit(
        "update-individual-test",
        testId,
        isChecked,
        panelId,
        caseTypeCode,
        testName,
        testCode,
        labOrderCode,
        testgoOrderCode,
        panelCode
      );
    },
    emitSelectPanelTests(panelCode, isChecked) {
      this.$emit("select-panel-tests", panelCode, isChecked);
    },
    emitUpdateReasons(reasons) {
      const notesFromReasons = reasons
        .map((reason) => this.reasonToActionMap[reason])
        .filter((action) => action)
        .join("\n");
      this.$emit("update-reasons", reasons);
      this.$emit("update-notes", notesFromReasons); // auto-fill
    },
    emitUpdateNotes(notes) {
      this.$emit("update-notes", notes);
    },
    validateAndEmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("form-validated");
        }
      });
    },
  },
};
</script>
 
<style lang="scss" scoped>
.testRejectedFooter {
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 1rem 10px;
}
 
.error-message {
  color: red;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}
 
.rejectedCases {
  max-height: 250px;
  overflow-y: scroll;
 
  .panelBlock {
    padding: 10px;
    position: relative;
 
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 0.8px;
      background-color: #e4e7ed;
      bottom: 0;
      left: 0;
    }
 
    .categoryOnlyHeader {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
 
      .panel-name {
        font-size: 14px;
        color: #273480;
        font-weight: 500;
      }
    }
 
    .testNamesGridBlock {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
 
      .testNames {
        .el-checkbox {
          height: auto;
        }
 
        .el-checkbox-group {
          .el-checkbox {
            height: 20px;
          }
 
          .el-checkbox__input {
            .el-checkbox__inner {
              border-color: transparent;
              box-shadow: 0 0 0 1px #ced1d6;
              border-radius: 4px;
              width: 17px;
              height: 17px;
            }
 
            &.is-checked {
              .el-checkbox__inner {
                background: #273480 !important;
                border-color: #ffffff !important;
                box-shadow: 0 0 0 1px #ced1d6 !important;
                width: 17px;
                height: 17px;
              }
            }
 
            .el-checkbox__inner::after {
              box-sizing: content-box;
              content: "";
              border: 2px solid var(--el-checkbox-checked-icon-color);
              border-left: 0;
              border-top: 0;
              height: 9px;
              left: 5px;
              position: absolute;
              top: 1px;
              transform: rotate(45deg) scaleY(1);
              width: 3px;
              transition: transform 0.15s ease-in 50ms;
              transform-origin: center;
            }
          }
 
          .el-checkbox__label {
            color: #34495e;
          }
        }
 
        .test-name {
          font-size: 13px;
          color: #333;
        }
      }
    }
  }
 
  .panelsGridWrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding-left: 10px;
    margin-top: 10px;
 
    .panelGridItem {
      display: flex;
      align-items: center;
 
      .panel-name {
        font-size: 14px;
        color: #273480;
        font-weight: 500;
      }
    }
  }
 
  .inline-panel {
    display: inline-block;
    margin-right: 50px;
    margin-bottom: 12px;
    margin-top: 10px;
    gap: 10px;
  }
}
</style>